module.exports = __webpack_public_path__ + "img/coprate.de173b1.svg";